(() => {
  if (window.zkSalesPage) return;
  window.zkSalesPage = true;

  const OFFER_HASH = '#sp-offer';

  const track = (name, data = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...data });
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish(name, data);
      }
    } catch (error) {}
  };

  const pad = (value) => String(value).padStart(2, '0');

  function initCountdowns(root) {
    root.querySelectorAll('[data-sp-countdown]:not([data-sp-ready])').forEach((element) => {
      element.dataset.spReady = 'true';

      const storageKey = `zkSpCountdown:${element.dataset.key || location.pathname}`;
      let end = 0;
      try {
        end = Number(sessionStorage.getItem(storageKey)) || 0;
      } catch (error) {}

      if (!end || end < Date.now()) {
        end = Date.now() + (Number(element.dataset.minutes) || 45) * 60000;
        try {
          sessionStorage.setItem(storageKey, String(end));
        } catch (error) {}
      }

      const hours = element.querySelector('[data-sp-hours]');
      const minutes = element.querySelector('[data-sp-minutes]');
      const seconds = element.querySelector('[data-sp-seconds]');

      const render = () => {
        const left = Math.max(0, end - Date.now());
        hours.textContent = pad(Math.floor(left / 3600000));
        minutes.textContent = pad(Math.floor(left / 60000) % 60);
        seconds.textContent = pad(Math.floor(left / 1000) % 60);
        if (!left) clearInterval(timer);
      };

      const timer = setInterval(render, 1000);
      render();
    });
  }

  function initGalleries(root) {
    root.querySelectorAll('[data-sp-gallery]:not([data-sp-ready])').forEach((gallery) => {
      gallery.dataset.spReady = 'true';

      const rail = gallery.querySelector('[data-sp-gallery-track]');
      const slides = Array.from(rail.children);
      const thumbs = Array.from(gallery.querySelectorAll('[data-sp-thumb]'));
      if (!slides.length) return;

      const currentIndex = () => Math.round(rail.scrollLeft / rail.clientWidth);
      const goTo = (index) => {
        const target = (index + slides.length) % slides.length;
        rail.scrollTo({ left: target * rail.clientWidth, behavior: 'smooth' });
      };

      gallery.querySelector('[data-sp-prev]')?.addEventListener('click', () => goTo(currentIndex() - 1));
      gallery.querySelector('[data-sp-next]')?.addEventListener('click', () => goTo(currentIndex() + 1));
      thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => goTo(index)));

      let frame;
      rail.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const index = currentIndex();
          thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
        });
      });
    });
  }

  function initSliders(root) {
    root.querySelectorAll('[data-sp-slider]:not([data-sp-ready])').forEach((slider) => {
      slider.dataset.spReady = 'true';

      const rail = slider.querySelector('[data-sp-slider-track]');
      const slides = Array.from(rail.children);
      const dotsWrap = slider.querySelector('[data-sp-slider-dots]');
      if (slides.length < 2 || !dotsWrap) return;

      const dots = slides.map((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'sp-slider__dot';
        dot.setAttribute('aria-label', `Show ${index + 1} of ${slides.length}`);
        dot.addEventListener('click', () => goTo(index));
        dotsWrap.appendChild(dot);
        return dot;
      });

      const currentIndex = () => Math.round(rail.scrollLeft / rail.clientWidth);
      const goTo = (index) => rail.scrollTo({ left: index * rail.clientWidth, behavior: 'smooth' });
      const updateDots = () => dots.forEach((dot, i) => dot.classList.toggle('is-active', i === currentIndex()));

      rail.addEventListener('scroll', () => requestAnimationFrame(updateDots));
      updateDots();

      const interval = Number(slider.dataset.autoplay) || 0;
      if (interval) {
        let paused = false;
        slider.addEventListener('pointerenter', () => (paused = true));
        slider.addEventListener('pointerleave', () => (paused = false));
        setInterval(() => {
          if (!paused && document.visibilityState === 'visible') goTo((currentIndex() + 1) % slides.length);
        }, interval * 1000);
      }
    });
  }

  function initSticky() {
    const sticky = document.querySelector('[data-sp-sticky]');
    if (!sticky || sticky.dataset.spReady) return;
    sticky.dataset.spReady = 'true';

    const primary = document.querySelector('[data-sp-primary-cta]');
    if (!primary || !('IntersectionObserver' in window)) {
      sticky.classList.add('is-visible');
      return;
    }

    new IntersectionObserver(([entry]) => {
      sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    }).observe(primary);
  }

  function lockScroll(locked) {
    document.documentElement.classList.toggle('sp-locked', locked);
  }

  function initVideoModal() {
    document.addEventListener('click', (event) => {
      const unmute = event.target.closest('[data-sp-unmute]');
      if (unmute) {
        const video = unmute.closest('[data-sp-media-hero]') && unmute.closest('[data-sp-media-hero]').querySelector('video');
        if (!video) return;
        video.muted = !video.muted;
        unmute.classList.toggle('is-unmuted', !video.muted);
        unmute.setAttribute('aria-pressed', String(!video.muted));
        unmute.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
        if (!video.muted) video.play().catch(() => {});
        return;
      }

      const trigger = event.target.closest('[data-sp-video]');
      if (!trigger) return;

      const section = trigger.closest('.sp-section') || document;
      const modal = section.querySelector('[data-sp-video-modal]') || document.querySelector('[data-sp-video-modal]');
      const video = modal && modal.querySelector('video');
      if (!video) return;

      const frame = modal.querySelector('.sp-video-modal__frame');
      if (frame) {
        const wide = trigger.dataset.spVideoLayout === 'wide' || Boolean(trigger.closest('[data-sp-media-hero]'));
        frame.classList.toggle('sp-video-modal__frame--wide', wide);
      }

      const inline = trigger.closest('[data-sp-media-hero]') && trigger.closest('[data-sp-media-hero]').querySelector('video');
      if (inline) inline.pause();

      video.src = trigger.dataset.spVideo;
      video.muted = false;
      modal.hidden = false;
      lockScroll(true);
      video.play().catch(() => {});
      track('sp_video_play', { video: trigger.dataset.spVideo });
    });

    document.addEventListener('click', (event) => {
      const modal = event.target.closest('[data-sp-video-modal]');
      if (!modal) return;
      if (event.target.closest('video') && !event.target.closest('[data-sp-video-close]')) return;
      closeVideo(modal);
    });
  }

  function closeVideo(modal) {
    const video = modal.querySelector('video');
    video.pause();
    video.removeAttribute('src');
    video.load();
    modal.hidden = true;
    lockScroll(false);

    document.querySelectorAll('[data-sp-media-hero] video').forEach((inline) => {
      inline.muted = true;
      inline.play().catch(() => {});
    });
    document.querySelectorAll('[data-sp-unmute]').forEach((button) => {
      button.classList.remove('is-unmuted');
      button.setAttribute('aria-pressed', 'false');
      button.setAttribute('aria-label', 'Unmute video');
    });
  }

  function openOffer(source) {
    const offer = document.querySelector('[data-sp-offer]');
    if (!offer) return false;

    offer.hidden = false;
    lockScroll(true);
    const selected = offer.querySelector('[data-offer-input]:checked') || offer.querySelector('[data-offer-input]');
    if (selected) selected.focus({ preventScroll: true });
    track('sp_offer_open', { source });
    return true;
  }

  function closeOffer() {
    const offer = document.querySelector('[data-sp-offer]');
    if (!offer || offer.hidden) return;
    offer.hidden = true;
    lockScroll(false);
  }

  function initOffer() {
    document.addEventListener('click', (event) => {
      const link = event.target.closest(`a[href$="${OFFER_HASH}"], [data-sp-open-offer]`);
      if (link) {
        if (openOffer(link.dataset.spSource || 'cta')) event.preventDefault();
        return;
      }

      const offer = event.target.closest('[data-sp-offer]');
      if (offer && (event.target === offer || event.target.closest('[data-sp-offer-close]'))) closeOffer();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      closeOffer();
      const modal = document.querySelector('[data-sp-video-modal]:not([hidden])');
      if (modal) closeVideo(modal);
    });

    if (location.hash === OFFER_HASH) openOffer('url');
  }

  function init(root = document) {
    initCountdowns(root);
    initGalleries(root);
    initSliders(root);
    initSticky();
  }

  initVideoModal();
  initOffer();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:select', (event) => {
    if (event.target.querySelector('[data-sp-offer]')) openOffer('editor');
  });
  document.addEventListener('shopify:section:deselect', (event) => {
    if (event.target.querySelector('[data-sp-offer]')) closeOffer();
  });
})();
